
/**
 * 프로젝트 메타 정보
 */
export type ProjectResponseMetaInfo = {
  tags?: string[];
};
